import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO16 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK001-6.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO16
